module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fPsGG"))).then(() => parcelRequire('d0iPb'));